import axios from 'axios'
function dealWithResult (data, resolve, reject) {
  if (data.data.code && parseInt(data.data.code) === 100) {
    resolve(data.data.data)
  } else {
    if (parseInt(data.data.code) === 401) {
      window.$router.replace('/login')
    }
    reject(data.data.message)
  }
}

function dealWithError (data, resolve, reject) {
  reject(data.status + ' ' + data.statusText)
}

function post (url, body, token, param) {
  return new Promise(function (resolve, reject) {
    axios.post(`/vue${url}`, body, {params: param, headers: {'token': (!token ? '' : token), 'locale': 'zh_CN'}}).then((response) => {
      dealWithResult(response, resolve, reject)
      // resolve()
    }, (response) => {
      dealWithError(response, resolve, reject)
      // reject()
    })
  })
}

function put (url, body, token, param) {
  return new Promise(function (resolve, reject) {
    axios.put(`/vue${url}`, body, {params: param, headers: {'token': (!token ? '' : token), 'locale': 'zh_CN'}}).then((response) => {
      dealWithResult(response, resolve, reject)
      // resolve()
    }, (response) => {
      dealWithError(response, resolve, reject)
      // reject()
    })
  })
}

function get (url, param, token) {
  return new Promise(function (resolve, reject) {
    axios.get(`/vue${url}`, {params: param, headers: {'token': (!token ? '' : token), 'locale': 'zh_CN'}}).then((response) => {
      dealWithResult(response, resolve, reject)
    }).catch((error) => {
      dealWithError(error, resolve, reject)
    })
  })
}

function deleted (url, param, token) {
  return new Promise(function (resolve, reject) {
    axios.delete(`/vue${url}`, {params: param, headers: {'token': (!token ? '' : token), 'locale': 'zh_CN'}}).then((response) => {
      dealWithResult(response, resolve, reject)
    }, (response) => {
      dealWithError(response, resolve, reject)
    })
  })
}

export const WE_OAUTH_URL = '/vue/oauth'
export default {
  queryUserInfo (companyId, employeeNo) {
    return get(`/queryUserInfo`, {companyId, employeeNo})
  },
  queryUserInfo2 (companyId, cardNo) {
    return get(`/queryUserInfo2`, {companyId, cardNo})
  },
  bindingWeixin (param) {
    return post(`/bindingWeixin`, param)
  },
  activateAccount (param) {
    return post('/activateAccount', param)
  },
  login (info) {
    return post('/login', info)
  },
  recharge (userInfo, payType, rechargeAmount) {
    return post('/recharge', { userId: userInfo.userId, companyId: userInfo.companyId, payType: payType, rechargeAmount: rechargeAmount }, userInfo.token)
  },
  // function put (url, body, token, query) {
  evaluate (userInfo, orderId, param) {
    return put('/evaluate', param, userInfo.token, {companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId})
  },
  getcommonPayInfo (userInfo, orderId, payType) {
    return put('/getcommonPayInfo', {}, userInfo.token, {companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId, payType: payType})
  },
  getPeriods (userInfo) {
    return get('/period', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId })
  },
  getHomePage (userInfo) {
    return get('/getHomePage', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId, hallId: userInfo.hallId })
  },
  getRecords (userInfo, type, page) {
    return get('/getRecords', { token: userInfo.token, userId: userInfo.userId, companyId: userInfo.companyId, type: type, page: page })
  },
  queryHallDishPopulayity (userInfo, start, end) {
    return get('/queryHallDishPopulayity', { userId: userInfo.userId, companyId: userInfo.companyId, start: start, end: end, periodPlanKind: 0 }, userInfo.token)
  },
  queryUserDishPopulayity (userInfo, start, end) {
    return get('/queryUserDishPopulayity', { userId: userInfo.userId, companyId: userInfo.companyId, start: start, end: end, periodPlanKind: 0 }, userInfo.token)
  },
  queryConsumeOrders (userInfo, start, end) {
    return get(`/queryConsumeOrders`, {companyId: userInfo.companyId, userId: userInfo.userId, start: start, end: end}, userInfo.token)
  },
  queryRecharges (userInfo, start, end) {
    return get(`/queryRecharges`, {companyId: userInfo.companyId, userId: userInfo.userId, start: start, end: end}, userInfo.token)
  },
  getOrderDetail (userInfo, orderId) {
    return get(`/getOrderDetail`, {token: userInfo.token, company: userInfo.companyId, user: userInfo.userId, orderId: orderId})
  },
  getBalance (userInfo) {
    return get('/getBalance', {userId: userInfo.userId, companyId: userInfo.companyId}, userInfo.token)
  },
  subscribestatus (userInfo) {
    return get(`/subscribestatus`, {companyId: userInfo.companyId, userId: userInfo.userId, openId: userInfo.openId, type: 'weixin'}, userInfo.token)
  },
  checkPhone (param) {
    return get(`/checkPhone`, param)
  },
  getVerificationCode (userInfo, phoneNumber) {
    return get(`/getVerificationCode?companyId=${userInfo.companyId}&userId=${userInfo.userId}&phoneNumber=${phoneNumber}`, {}, userInfo.token)
  },
  getVerificationCode2 (phoneNumber) {
    return get(`/getVerificationCode2`, {phoneNumber})
  },
  getPeriodMenus (userInfo, hallId, periodPlanId) {
    return get(`/getPeriodMenus?userId=${userInfo.userId}&companyId=${userInfo.companyId}`, {hallId: hallId, periodPlanId: periodPlanId}, userInfo.token)
  },
  addOrder (userInfo, param) {
    return post(`/addOrder`, param, userInfo.token, userInfo)
  },
  getPayInfo (userInfo, orderIds, payType) {
    return get(`/pay?user=${userInfo.userId}&openId=${userInfo.openId ? userInfo.openId : ''}&orderIds=${orderIds}&payType=${payType}`, {}, userInfo.token)
  },
  modifyPwd (param) {
    return get('/modifyPwd', param, param.token)
  },
  deleteOrder (userInfo, orderId) {
    return deleted('/deleteOrder', {token: userInfo.token, companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId})
  },
  getPersonQrCodeString (userInfo) {
    return get('/getPersonQrCodeString', userInfo, userInfo.token)
  },
  getAddressList (companyId) {
    return get('/getAddressList', {companyId: companyId})
  },
  transferBedWithAddress (userInfo, orderId, address) {
    return get('/transferBedWithAddress', {companyId: userInfo.companyId, userId: userInfo.userId, orderId: orderId, address: address}, userInfo.token)
  },
  getPatientInfo (userInfo, patientNo) {
    return get(`/getPatientInfo`, {userId: userInfo.userId, companyId: userInfo.companyId, patientNo: patientNo}, userInfo.token)
  },
  companyInfo (companyName) {
    return get(`/companies`, {companyName})
  },
  getUserDeliveryAddress (userInfo) {
    return get(`/getUserDeliveryAddress`, userInfo, userInfo.token)
  },
  addUserDeliveryAddress (userInfo, param) {
    return post(`/addUserDeliveryAddress`, param, userInfo.token, userInfo)
  },
  deleteUserDeliveryAddress (userInfo, addressId) {
    return deleted(`/deleteUserDeliveryAddress`, {userId: userInfo.userId, companyId: userInfo.companyId, addressId: addressId}, userInfo.token)
  },
  unbindingWeixin (userInfo) {
    return post(`/unbindingWeixin`, {companyId: userInfo.companyId, userId: userInfo.userId}, userInfo.token)
  },
  bindingPhoneNumber (userInfo, param) {
    return post(`/bindingPhoneNumber`, param, userInfo.token)
  },
  weixinSignUpNew (param) {
    return post(`/weixinSignUpNew`, param)
  },
  weixinSignUpBindOld (param) {
    return post(`/weixinSignUpBindOld`, param)
  },
  weixinSignUpNewCardNo (param) {
    return post(`/weixinSignUpNewCardNo`, param)
  },
  weixinSignUpBindOldCardNo (param) {
    return post(`/weixinSignUpBindOldCardNo`, param)
  },
  searchUserInfo (param) {
    return get(`/searchUserInfo`, param)
  },
  weixinActivation (param) {
    return post(`/weixinActivation`, param)
  },
  changeCard (userInfo, param) {
    return post(`/changeCard`, param, userInfo.token)
  },
  // 用户查询银行卡签约接口
  querySubscription (userInfo) {
    return get(`/querySubscription`, {userId: userInfo.userId, companyId: userInfo.companyId}, userInfo.token)
  },
  relieveSubscription (userInfo) {
    return deleted(`/relieveSubscription`, {userId: userInfo.userId, companyId: userInfo.companyId}, userInfo.token)
  },
  getQuickBill (userInfo) {
    return get(`/getQuickBill`, {userId: userInfo.userId, companyId: userInfo.companyId, pageNo: 1, pageSize: 10000, baseOrderViewStatus: 'NOT_CONSUME,CONSUMED,COMMENTED'}, userInfo.token)
  }
  // deleteUserDeliveryAddress (userInfo, addressId) {
  //   return deleted(`/deleteUserDeliveryAddress`, {userId: userInfo.userId, companyId: userInfo.companyId, addressId: addressId}, userInfo.token)
  // }
}



// WEBPACK FOOTER //
// ./src/api/index.js